"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const styled_components_1 = require("styled-components");
const breakpoints_1 = __importDefault(require("../breakpoints"));
const breakpoints = Object.keys(breakpoints_1.default);
const getMediaQueryString = (field, values = {}) => {
    let queryString = "";
    breakpoints.forEach((bp, i) => {
        if (values[bp] && values[bp] !== values[breakpoints[i - 1]]) {
            queryString += `@media (min-width: ${breakpoints_1.default[bp]}px) {
        ${field}: ${values[bp]};
      }`;
        }
    });
    return queryString;
};
/**
 * Mobile-first responsive helper that generates media queries with different css styles
 * per each breakpoint key that is passed in for a css property. If a breakpoint, is excluded,
 * the value of the next smallest breakpoint that is present is used.
 *
 * Eg: mobileFirstResponsive({field: "width", values: { xs: "100%", md: "50%" } }) applies
 * the css width: 100%; to the xs and sm screens, width: 50%; to md, lg, and xl screen sizes
 *
 * @param field
 * @param values
 * @returns string of media queries wrapped in styled components css helper
 */
const mobileFirstResponsive = ({ field, values = {} }) => (0, styled_components_1.css) `
  ${getMediaQueryString(field, values)}
`;
exports.default = mobileFirstResponsive;
//# sourceMappingURL=responsive.js.map